import { jsx as _jsx } from "react/jsx-runtime";
import { PhoneConnectedFilledIcon } from '@getgo/chameleon-icons/react';
import { Alert } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import classes from './CallEvent.module.scss';
import TextTime from './TextTime';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const CallEvent = ({ call, fullWidth, compact }) => {
    console.warn('CallEvent is deprecated, use @ucc-messaging/inbox-common-ui instead');
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.content, {
            [classes.fullWidth]: fullWidth,
            [classes.compact]: compact,
        }) }, { children: _jsx(Alert, Object.assign({ icon: _jsx(PhoneConnectedFilledIcon, {}, void 0), variant: "info", className: classes.alert }, { children: _jsx(TextTime, { text: t('This conversation was flipped to a phone call'), time: call.createdAt }, void 0) }), void 0) }), void 0));
};
export default CallEvent;
//# sourceMappingURL=CallEvent.js.map